import {observer} from 'mobx-react-lite'
import React from 'react'
import tw from 'tailwind-styled-components'
import {Lang} from 'yougile-lang'
import {TimelineFilter} from 'yougile-model'
import {Help} from '@components/common/help/help'
import {globals} from '@extensions/globals-base'
import {useStatsTimelineStore} from '../stats-timeline-store'
import {Download} from './download-xlsx/download'
import {Toggle} from './toggle-view/toggle-view'
import {TopMenu} from './top-menu/top-menu'

const TwHeader = tw.div`
  flex
  pl-24
  py-16
  pr-16
  bg-header-old
  z-10
  flex-col
  border
  border-t-0
  border-l-0
  border-r-0
  border-solid
  border-main-old
  rounded-t-4
`
type TwProps = {
  $active: boolean
}
const TwFilter = tw.button<TwProps>`
${p =>
  p.$active
    ? 'text-main-old border-obscure-main-old font-semibold'
    : 'text-action-default border-bg-header-old'}
  mr-32
  cursor-pointer
  text-12
  truncate
  pb-2
  mb-12
  border-t-0
  border-l-0
  border-r-0
  border-solid
  border-2
  rounded-2
`

export const Header = observer(({filters}: {filters: TimelineFilter[]}) => {
  const currentCompanyId = globals.getCompanyId()
  const filtersForCurrentCompany = filters.filter(
    filter =>
      filter.relevantCompanyId === currentCompanyId || !filter.relevantCompanyId
  )
  const [state, store] = useStatsTimelineStore()
  return (
    <TwHeader>
      <div className="flex justify-between mb-8">
        <div className="flex overflow-x-auto">
          <Help name="timelineReport" className="mr-12 min-w-24" />
          <div className="flex items-baseline">
            {filtersForCurrentCompany.length > 0 && (
              <span className="text-third-old whitespace-nowrap">
                {Lang.msg.statsTimeline.savedFilters}:
              </span>
            )}
            {filtersForCurrentCompany.length > 0 && (
              <div className="flex flex-wrap flex-1 mx-24">
                {filtersForCurrentCompany.map(({title, id}) => (
                  <TwFilter
                    $active={state.filter.id === id}
                    key={id}
                    onClick={() => store.setActiveFilter(id)}
                  >
                    {title}
                  </TwFilter>
                ))}
              </div>
            )}
          </div>
        </div>
        <Download />
      </div>
      <div className="flex">
        <Toggle />
        <TopMenu />
      </div>
    </TwHeader>
  )
})
